var _excluded = ["onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { useKeyPressEvent } from 'react-use';
import { useMenuContext } from "../useMenuContext";
import { mergeRefs, callAllHandlers } from "../../../helpers/common";

var useMenuButton = function useMenuButton(props) {
  var externalRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _useMenuContext = useMenuContext(),
      buttonRef = _useMenuContext.buttonRef,
      popper = _useMenuContext.popper,
      onToggle = _useMenuContext.onToggle,
      onClose = _useMenuContext.onClose,
      openAndFocusFirstItem = _useMenuContext.openAndFocusFirstItem;

  var onClickProp = props.onClick,
      restProps = _objectWithoutProperties(props, _excluded);

  var onClick = callAllHandlers(onToggle, onClickProp);
  useKeyPressEvent('Space', openAndFocusFirstItem);
  useKeyPressEvent('Enter', openAndFocusFirstItem);
  useKeyPressEvent('Escape', onClose);
  useKeyPressEvent('Tab', function (event) {
    return event.preventDefault();
  });
  return _objectSpread(_objectSpread({}, restProps), {}, {
    onClick: onClick,
    ref: mergeRefs(buttonRef, externalRef, popper.referenceRef)
  });
};

export { useMenuButton };
export default useMenuButton;